import { render, staticRenderFns } from "./PaymentNewComputerConfig.vue?vue&type=template&id=1aed621c&scoped=true"
import script from "./PaymentNewComputerConfig.vue?vue&type=script&lang=ts"
export * from "./PaymentNewComputerConfig.vue?vue&type=script&lang=ts"
import style0 from "./PaymentNewComputerConfig.vue?vue&type=style&index=0&id=1aed621c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aed621c",
  null
  
)

export default component.exports